import { SupportedLanguage } from '@foundation/localization';

import {
  BraintreeApplePayLocale,
  BraintreePayPalLocale,
  BraintreeSepaLocale,
  GooglePayLocale,
} from '@/services/braintree';

export const SepaSupportedLocale: {
  [key in SupportedLanguage]: BraintreeSepaLocale;
} = {
  [SupportedLanguage.Bulgarian]: 'en-US', // Bulgarian is not supported
  [SupportedLanguage.Czech]: 'cs-CZ',
  [SupportedLanguage.ChineseSimplifiedChina]: 'zh-CN',
  [SupportedLanguage.ChineseTraditionalHongKong]: 'zh-HK',
  [SupportedLanguage.Danish]: 'da-DK',
  [SupportedLanguage.Dutch]: 'nl-NL',
  [SupportedLanguage.English]: 'en-US',
  [SupportedLanguage.Finnish]: 'fi-FI',
  [SupportedLanguage.French]: 'fr-FR',
  [SupportedLanguage.German]: 'de-DE',
  [SupportedLanguage.Hungarian]: 'hu-HU',
  [SupportedLanguage.Indonesian]: 'id-ID',
  [SupportedLanguage.Italian]: 'it-IT',
  [SupportedLanguage.Japanese]: 'ja-JP',
  [SupportedLanguage.Korean]: 'ko-KR',
  [SupportedLanguage.Norwegian]: 'no-NO',
  [SupportedLanguage.Polish]: 'pl-PL',
  [SupportedLanguage.Portuguese]: 'pt-PT',
  [SupportedLanguage.Russian]: 'ru-RU',
  [SupportedLanguage.Spanish]: 'es-ES',
  [SupportedLanguage.Swedish]: 'sv-SE',
  [SupportedLanguage.Thai]: 'th-TH',
  [SupportedLanguage.Turkish]: 'en-US', // Turkish is not supported
  [SupportedLanguage.Ukrainian]: 'en-US', // Ukrainian is not supported
  [SupportedLanguage.Vietnamese]: 'en-US',
  [SupportedLanguage.Icelandic]: 'en-US',
  [SupportedLanguage.Lithuanian]: 'en-US',
  [SupportedLanguage.Romanian]: 'en-US',
  [SupportedLanguage.Estonian]: 'en-US',
  [SupportedLanguage.Malaysian]: 'en-US',
  [SupportedLanguage.Latvian]: 'en-US',
  [SupportedLanguage.ChineseTraditionalTaiwan]: 'zh-TW',
};

export const PayPalSupportedLocale: {
  [key in SupportedLanguage]: BraintreePayPalLocale;
} = {
  [SupportedLanguage.Bulgarian]: 'en_US', // Bulgarian is not supported by PayPal
  [SupportedLanguage.Czech]: 'en_US', // Czech is not supported by PayPal
  [SupportedLanguage.ChineseSimplifiedChina]: 'zh_CN',
  [SupportedLanguage.ChineseTraditionalHongKong]: 'zh_HK',
  [SupportedLanguage.Danish]: 'da_DK',
  [SupportedLanguage.Dutch]: 'nl_NL',
  [SupportedLanguage.English]: 'en_US',
  [SupportedLanguage.Finnish]: 'en_US', // Finish is not supported by PayPal
  [SupportedLanguage.French]: 'fr_FR',
  [SupportedLanguage.German]: 'de_DE',
  [SupportedLanguage.Hungarian]: 'en_US', // Hungarian is not supported by PayPal
  [SupportedLanguage.Indonesian]: 'id_ID',
  [SupportedLanguage.Italian]: 'it_IT',
  [SupportedLanguage.Japanese]: 'ja_JP',
  [SupportedLanguage.Korean]: 'ko_KR',
  [SupportedLanguage.Norwegian]: 'no_NO',
  [SupportedLanguage.Polish]: 'pl_PL',
  [SupportedLanguage.Portuguese]: 'pt_PT',
  [SupportedLanguage.Russian]: 'ru_RU',
  [SupportedLanguage.Spanish]: 'es_ES',
  [SupportedLanguage.Swedish]: 'sv_SE',
  [SupportedLanguage.Thai]: 'th_TH',
  [SupportedLanguage.Turkish]: 'en_US', // Turkish is not supported by PayPal
  [SupportedLanguage.Ukrainian]: 'en_US', // Ukrainian is not supported by PayPal
  [SupportedLanguage.Vietnamese]: 'en_US',
  [SupportedLanguage.Icelandic]: 'en_US',
  [SupportedLanguage.Lithuanian]: 'en_US',
  [SupportedLanguage.Romanian]: 'en_US',
  [SupportedLanguage.Estonian]: 'en_US',
  [SupportedLanguage.Malaysian]: 'en_US',
  [SupportedLanguage.Latvian]: 'en_US',
  [SupportedLanguage.ChineseTraditionalTaiwan]: 'zh_TW',
};

export const ApplePaySupportedLocale: {
  [key in SupportedLanguage]: BraintreeApplePayLocale;
} = {
  [SupportedLanguage.Bulgarian]: 'en-US', // Bulgarian is not supported by Apple Pay
  [SupportedLanguage.Czech]: 'cs-CZ',
  [SupportedLanguage.ChineseSimplifiedChina]: 'zh-CN',
  [SupportedLanguage.ChineseTraditionalHongKong]: 'zh-HK',
  [SupportedLanguage.Danish]: 'da-DK',
  [SupportedLanguage.Dutch]: 'nl-NL',
  [SupportedLanguage.English]: 'en-US',
  [SupportedLanguage.Finnish]: 'fi-FI',
  [SupportedLanguage.French]: 'fr-FR',
  [SupportedLanguage.German]: 'de-DE',
  [SupportedLanguage.Hungarian]: 'hu-HU',
  [SupportedLanguage.Indonesian]: 'id-ID',
  [SupportedLanguage.Italian]: 'it-IT',
  [SupportedLanguage.Japanese]: 'ja-JP',
  [SupportedLanguage.Korean]: 'ko-KR',
  [SupportedLanguage.Norwegian]: 'nb-NO',
  [SupportedLanguage.Polish]: 'pl-PL',
  [SupportedLanguage.Portuguese]: 'pt-PT',
  [SupportedLanguage.Russian]: 'ru-RU',
  [SupportedLanguage.Spanish]: 'es-ES',
  [SupportedLanguage.Swedish]: 'sv-SE',
  [SupportedLanguage.Thai]: 'th-TH',
  [SupportedLanguage.Turkish]: 'tr-TR',
  [SupportedLanguage.Ukrainian]: 'uk-UA',
  [SupportedLanguage.Vietnamese]: 'vi-VN',
  [SupportedLanguage.Icelandic]: 'en-US',
  [SupportedLanguage.Lithuanian]: 'en-US',
  [SupportedLanguage.Romanian]: 'ro-RO',
  [SupportedLanguage.Estonian]: 'en-US',
  [SupportedLanguage.Malaysian]: 'ms-MY',
  [SupportedLanguage.Latvian]: 'en-US',
  [SupportedLanguage.ChineseTraditionalTaiwan]: 'zh-TW',
};

export const GooglePaySupportedLocale: {
  [key in SupportedLanguage]: GooglePayLocale;
} = {
  [SupportedLanguage.Bulgarian]: 'bg',
  [SupportedLanguage.Czech]: 'cs',
  [SupportedLanguage.ChineseSimplifiedChina]: 'zh',
  [SupportedLanguage.ChineseTraditionalHongKong]: 'zh',
  [SupportedLanguage.Danish]: 'da',
  [SupportedLanguage.Dutch]: 'nl',
  [SupportedLanguage.English]: 'en',
  [SupportedLanguage.Finnish]: 'fi',
  [SupportedLanguage.French]: 'fr',
  [SupportedLanguage.German]: 'de',
  [SupportedLanguage.Hungarian]: 'en', // Hungarian is not supported by Google Pay
  [SupportedLanguage.Indonesian]: 'id',
  [SupportedLanguage.Italian]: 'it',
  [SupportedLanguage.Japanese]: 'ja',
  [SupportedLanguage.Korean]: 'ko',
  [SupportedLanguage.Norwegian]: 'no',
  [SupportedLanguage.Polish]: 'pl',
  [SupportedLanguage.Portuguese]: 'pt',
  [SupportedLanguage.Russian]: 'ru',
  [SupportedLanguage.Spanish]: 'es',
  [SupportedLanguage.Swedish]: 'sv',
  [SupportedLanguage.Thai]: 'th',
  [SupportedLanguage.Turkish]: 'tr',
  [SupportedLanguage.Ukrainian]: 'uk',
  [SupportedLanguage.Vietnamese]: 'en',
  [SupportedLanguage.Icelandic]: 'en',
  [SupportedLanguage.Lithuanian]: 'en',
  [SupportedLanguage.Romanian]: 'en',
  [SupportedLanguage.Estonian]: 'et',
  [SupportedLanguage.Malaysian]: 'ms',
  [SupportedLanguage.Latvian]: 'en',
  [SupportedLanguage.ChineseTraditionalTaiwan]: 'zh',
};
